import { Role } from '@/api';
import { useAuthContext } from '@/context/auth-context';

const GPM_ROLES: ReadonlySet<string> = new Set([
  Role.Admin,
  Role.GlobalPricingManager,
  Role.LegoExtendedLinePricingManager,
]);

export const useUserRole = () => {
  const { user } = useAuthContext();
  const roles = user?.roles ?? [];

  return {
    isAdmin: roles.some((r) => r === Role.Admin),
    isGlobalPriceManager: roles.some((r) => GPM_ROLES.has(r)),
    isLocalPriceManager: roles.some((r) => r === Role.LocalPricingManager),
    roles,
  };
};
